// extracted by mini-css-extract-plugin
export default {"player":"audio_player__tLwma","playerButton":"audio_playerButton__2YGTA","title":"audio_title__a2yqj","composer":"audio_composer__1uixx"};